module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5 col-xs-offset-1 col-md-4 col-md-offset-2"
  }, [_c('button', {
    class: _vm.locked ? 'btn btn-danger disabled' : 'btn btn-danger',
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onNo
    }
  }, [_c('span', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 col-md-4"
  }, [_c('button', {
    class: _vm.locked ? 'btn btn-success disabled' : 'btn btn-success',
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onYes
    }
  }, [_c('span', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4984e98c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/buttons.vue
// module id = 52
// module chunks = 0